import React from 'react'
import { connect } from 'react-redux'
import { 
    Button, Form, FormCell, CellBody, CellFooter, CellHeader, Label, Input,
    Dialog, Toptips, Toast
} from 'react-weui'
import { browserHistory } from 'react-router'
import axios from 'axios'
import qs from 'qs'
import { Page, WKTab } from '../../components'
import { WKVisible } from '../../components/wk'
import {filterHTML} from "../../utils"
import ResellStore from './ResellStore'
import '../../css/page/ResellPage.css'


class RecellRecruitPage extends React.Component {
    constructor (props) {
        super(props)
        // 获取验证码的时间间隔s
        this.COUNT_DOWN = 60
        this.isSending = false
        this.state = {
            name: '',
            contact: '',
            captcha: '',
            second: this.COUNT_DOWN,
            isPending: false,
            info: {},
            isShowForm: false,
            submitCode: '',
            isPageClose: false,
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        document.title = '直播间分销商招募'
        this.fetchData()
    }
    setShareInfo (data) {
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: data,
        })
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/resell/liveroom/${this.props.params.id}/agent/info`)
            .then(res => {
                const data = res.data.data
                this.setState({ isPending: false })
                if (res.data.code === 0) {
                    this.setState({ 
                        info: { ...res.data.data.setting, process: res.data.data.process },
                    })
                    
                    this.handleProcess(res.data.data.process, res.data.data.setting.process)
                    this.setShareInfo({
                        title: data.share_info.share_title,
                        desc: data.share_info.share_description,
                        imgUrl: data.share_info.share_icon,
                        link: data.share_info.share_url,
                    })
                } else {
                    this.setState({ 
                        isPageClose: true,
                        info: { ...res.data.data.setting, process: res.data.data.process },
                    })
                }
            })
    }
    componentWillUnmount () {
        clearInterval(this.timer)
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    handleClickSendBtn () {
        if (this.state.second < this.COUNT_DOWN) {
            return
        }
        const contact = this.state.contact
        if (contact.toString().length !== 11 || !+contact) {
            return this.showTip('请填写正确的11位数字手机号码')
        } else {
            this.postSendCaptcha()
        }
    }
    postSendCaptcha () {
        if (this.isSending) {
            return
        }
        this.isSending = true
        return axios.post('/api/board/sms/send_verify_code', qs.stringify({
            phone: this.state.contact,
        }))
            .then(res => {
                this.isSending = false
                if (res.data.code !== 0) {
                    this.showTip(res.data.msg)
                    return
                }
                this.setState({ 
                    second: this.state.second - 1,
                })
                this.timer = setInterval(() => {
                    if (this.state.second <= 1) {
                        this.setState({ second: this.COUNT_DOWN })
                        clearInterval(this.timer)
                        return
                    }
                    this.setState({ second: this.state.second - 1 })
                }, 1000)
                this.showTip('验证码已发送，请查看手机短信', 'primary')
            })
            .catch(err => {
                this.isSending = false
            })
    }
    showTip (text, type = 'warn', isLong) {
        this.setState({
            tip: { isShow: true, text, type },
        })
        if (isLong) {
            
        } else {
            setTimeout(() => {
                this.setState({
                    tip: { isShow: false },
                })
            }, 2000)
        }
    }
    showAlert (msg) {
        this.setState({
            alertDialog: {
                isShow: true,
                text: msg,
            }
        })
    }
    onClickApply () {
        if (this.state.info.process === 'reviewing') {
            return
        }
        this.setState({ isShowForm: true, tip: { isShow: false } })
        setTimeout(() => {
            this.$form.scrollIntoView({ behavior: 'smooth' })
            // window.scrollBy({ top: this.getTotalHeight() + 1000, left: 0, behavior: 'smooth' })
        }, 300)
    }
    handleProcess (state, isEnabled) {
        switch (state) {
            case 'normal':
                break
            case 'approved':
                location.assign(`/resell/liveroom/${this.props.params.id}`)
                break
            case 'reviewing':
                this.showTip('信息审核中，请等候或联系直播间管理者', 'primary', true)
                break
            case 'rejected':
                this.showTip('申请已被拒绝，你可以重新申请', 'warn', true)
                break
            default:
                break
        }
    }
    getTotalHeight () {
        return document.documentElement.clientHeight + (document.body.scrollTop || document.documentElement.scrollTop)
    }
    getApplyBtnText () {
        if (!this.state.info.enabled) {
            return '招募已关闭'
        }
        switch (this.state.info.process) {
            case 'reviewing':
                return '已申请'
            default:
                return '我要申请'
        }
    }
    submit () {
        if (this.state.contact.toString().length !== 11 || !+this.state.contact) {
            this.showTip('请填写正确的11位数字手机号码')
            return
        }
        if (this.state.captcha === '') {
            this.showTip('请填写验证码')
            return
        }
        if (this.state.name.trim() === '') {
            this.showTip('请填写姓名')
            return
        }
        axios.post(`/api/resell/liveroom/${this.props.params.id}/agent/signup`, qs.stringify({
            phone: this.state.contact,
            verify_code: this.state.captcha,
            nickname: this.state.name.trim(),
        }))
            .then(res => {
                this.setState({ submitCode: res.data.code })
                if (res.data.code === 0) {
                    this.state.info.process = 'reviewing'
                    this.setState({ info: this.state.info, isShowForm: false })
                    this.handleProcess('reviewing')
                }
                if (res.data.code === -1) {
                    this.setState({
                        alertDialog: { isShow: true, text: '申请通过，你已成为直播间分销商', btnText: '立即分销' }
                    })
                }
                if (res.data.code > 0) {
                    this.setState({
                        alertDialog: { isShow: true, text: res.data.msg, btnText: '确定' }
                    })
                }
            })
    }
    onClickDialogOk () {
        if (this.state.submitCode === -1) {
            location.assign(`/resell/liveroom/${this.props.params.id}`)
        } else {
            this.setState({ alertDialog: { isShow: false } })
        }
    }
    onClickNameInput () {
        if (window.systemType === 'android') {
            this.$submit.scrollIntoView(false)
        }
    }
    render() {
        const info = this.state.info
        const desc = info.description || ''
        const { isPageClose } = this.state
        const isApplyBtnDisabled = info.process === 'reviewing' || !info.enabled
        return (
            <div className="resell-recruit-page wk-page">
                {
                    !isPageClose && (
                        <div className="html-content">
                            <div dangerouslySetInnerHTML={{__html: filterHTML(desc.replace(/&nbsp;/g, ''))}} />
                        </div>
                    )
                }
                {
                    isPageClose && (
                        <p style={{textAlign: 'center', color: '#999', fontSize: '14px', paddingTop: '100px'}}>
                            功能暂时维护中
                        </p>
                    )
                }
                <WKVisible className='form-wrap' show={this.state.isShowForm}>
                    <div ref={r => this.$form = r} className="form">
                        <Form>
                            <FormCell>
                                <CellHeader>
                                    <Label>姓名</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input onClick={e => this.onClickNameInput()} value={this.state.name} onChange={e => this.bindValue(e, 'name')} placeholder="请输入姓名"/>
                                </CellBody>
                            </FormCell>
                            <FormCell>
                                <CellHeader>
                                    <Label>电话</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input value={this.state.contact} onChange={e => this.bindValue(e, 'contact')} type="tel" placeholder="请输入电话号码"/>
                                </CellBody>
                            </FormCell>
                            <FormCell vcode>
                                <CellHeader>
                                    <Label>验证码</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input 
                                        value={this.state.captcha} 
                                        onChange={e => this.bindValue(e, 'captcha')} 
                                        type="number" 
                                        pattern='[0-9]*'
                                        placeholder="请输入验证码" 
                                    />
                                </CellBody>
                                <CellFooter>
                                    <Button 
                                        onClick={e => this.handleClickSendBtn()} 
                                        type="vcode" 
                                        disabled={this.state.second < this.COUNT_DOWN}
                                    >
                                        <span className='normal-font'>
                                            {this.state.second < this.COUNT_DOWN ? `${this.state.second}s后重新获取` : '获取验证码'}
                                        </span>
                                    </Button>
                                </CellFooter>
                            </FormCell>
                        </Form>
                        <div className="wk-btn-90" ref={r => this.$submit = r}>
                            <Button onClick={e => this.submit()}>提交</Button>
                        </div>
                    </div>
                </WKVisible>

                <WKVisible show={!this.state.isShowForm && !this.state.isPending}>
                    <Button disabled={isApplyBtnDisabled} className='apply-btn' onClick={e => this.onClickApply()}>
                        {this.getApplyBtnText()}
                    </Button>
                </WKVisible>

                {/* 成功dialog  */}
                <Dialog type="ios" title='' buttons={[
                    { type: 'primary', label: this.state.alertDialog.btnText || '确定', onClick: () => this.onClickDialogOk() },
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                {/* loading toast  */}
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default connect()(RecellRecruitPage)


// WEBPACK FOOTER //
// ./src/pages/resell/ResellRecruitPage.js